import API_CONFIG from '../api-config';
import axios from 'axios/index';
import CONSTANTS from '../constants';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

axios.defaults.headers.common['Content-Type'] = 'application/json';

const apiService = {
    getApiEndPoint(url, params, type = CONSTANTS.ENDPOINT_SERVICE.API) {
        let apiLink = '';
        if (url.indexOf('http') > -1) {
            apiLink = url;
        } else {
            apiLink = API_CONFIG.BASE_URL + get(API_CONFIG, url);
        }

        const requestParams = params;
        if (get(requestParams, 'endpointSubfix')) {
            apiLink += requestParams.endpointSubfix;
            delete requestParams.endpointSubfix;
        }

        if (!isNil(get(params, 'id'))) {
            if (apiLink.indexOf(':id') > -1) {
                apiLink = apiLink.replace(/:id/g, requestParams.id);
            }
        }

        return { apiLink, requestParams };
    },
    get(url, params, type = CONSTANTS.ENDPOINT_SERVICE.API) {
        const { apiLink, requestParams } = this.getApiEndPoint(url, params, type);
        return axios
            .get(apiLink, {
                params: requestParams
            })
            .then(response => response.data);
    },
    post(url, params, type = CONSTANTS.ENDPOINT_SERVICE.API) {
        const { apiLink, requestParams } = this.getApiEndPoint(url, params, type);
        return axios.post(apiLink, requestParams).then(response => response.data);
    },
    put(url, params, type = CONSTANTS.ENDPOINT_SERVICE.API) {
        const { apiLink, requestParams } = this.getApiEndPoint(url, params, type);
        return axios.put(apiLink, requestParams).then(response => response.data);
    },
    delete(url, params, type = CONSTANTS.ENDPOINT_SERVICE.API) {
        const { apiLink, requestParams } = this.getApiEndPoint(url, params, type);
        return axios.delete(apiLink, { params: requestParams }).then(response => response.data);
    },
    postForm(url, params) {
        const { apiLink } = this.getApiEndPoint(url, params, CONSTANTS.ENDPOINT_SERVICE.API);
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
        return axios.post(apiLink, params.formData, { headers }).then(response => response.data);
    },
    download(url, params) {
        const { apiLink } = this.getApiEndPoint(url, params, CONSTANTS.ENDPOINT_SERVICE.API);
        return axios.post(apiLink, {}, { responseType: 'blob' }).then(response => response.data);
    }
};

export default apiService;
